import { useEffect, useRef, useState } from 'react';
const TYPING_SPEED_MS_PER_CHAR = 70; // Realistic typing speed
const PAUSE_BETWEEN_CYCLES_MS = 1500; // Brief pause to read complete text
const DELETION_SPEED_MS_PER_CHAR = 30; // Faster deletion for better UX
const PAUSE_BETWEEN_DELETIONS_MS = 800; // Brief pause to read complete text

export const usePlaceholder = (placeholder, query) => {
  const placeholders = Array.isArray(placeholder) ? placeholder : [placeholder || ''];
  const _useState = useState(0),
    currentPlaceholderIndex = _useState[0],
    setCurrentPlaceholderIndex = _useState[1];
  const currentPlaceholder = placeholders[currentPlaceholderIndex];
  const intervalRef = useRef(null);
  const previousQueryRef = useRef(query);
  const typingDuration = currentPlaceholder.length * TYPING_SPEED_MS_PER_CHAR;
  const pauseDuration = PAUSE_BETWEEN_CYCLES_MS;
  const deletingDuration = currentPlaceholder.length * DELETION_SPEED_MS_PER_CHAR;
  const pauseBetweenDeletionsDuration = PAUSE_BETWEEN_DELETIONS_MS;
  useEffect(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
    if (query) {
      if (!previousQueryRef.current) {
        setCurrentPlaceholderIndex(prev => (prev + 1) % placeholders.length);
      }
      previousQueryRef.current = query;
      return;
    }
    previousQueryRef.current = query;
    if (placeholders.length <= 1) {
      return;
    }
    const totalCycleDuration = typingDuration + pauseDuration + deletingDuration + pauseBetweenDeletionsDuration;
    intervalRef.current = setInterval(() => {
      setCurrentPlaceholderIndex(prev => (prev + 1) % placeholders.length);
    }, totalCycleDuration);
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [query, typingDuration, pauseDuration, deletingDuration, placeholders.length, pauseBetweenDeletionsDuration]);
  return {
    placeholders,
    currentPlaceholder,
    currentPlaceholderIndex,
    typingDuration,
    pauseDuration,
    deletingDuration,
    pauseBetweenDeletionsDuration
  };
};
//# sourceMappingURL=usePlaceholder.js.map